/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface LineItemRefundBase
 */
export interface LineItemRefundBaseOptional {
  /**
   *
   * @type {number}
   * @memberof LineItemRefundBase
   */
  amountToRefundUnitCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundBase
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundBase
   */
  refundQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundBase
   */
  returnStock?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundBase
   */
  revokeAfter?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundBase
   */
  revokeDuring?: boolean;
}

export interface LineItemRefundBase extends LineItemRefundBaseOptional {
  /**
   *
   * @type {number}
   * @memberof LineItemRefundBase
   */
  amountToRefundUnitCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundBase
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundBase
   */
  refundQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundBase
   */
  returnStock?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundBase
   */
  revokeAfter?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundBase
   */
  revokeDuring?: boolean;
}

export interface LineItemRefundBaseTrackedI {
  /**
   *
   * @type {number}
   * @memberof LineItemRefundBase
   */
  amountToRefundUnitCents?: number;
  amountToRefundUnitCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundBase
   */
  amountRefundedCents?: number;
  amountRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundBase
   */
  refundQuantity?: number;
  refundQuantityIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundBase
   */
  returnStock?: boolean;
  returnStockIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundBase
   */
  revokeAfter?: boolean;
  revokeAfterIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundBase
   */
  revokeDuring?: boolean;
  revokeDuringIsSet: boolean;
}

transformDatesMap.set(
  "LineItemRefundBase",
  function (model: LineItemRefundBase) {},
);

export type LineItemRefundBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  amountToRefundUnitCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  refundQuantity: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  returnStock: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  revokeAfter: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  revokeDuring: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var LineItemRefundBaseMeta: LineItemRefundBaseMetaI =
  {} as LineItemRefundBaseMetaI;
LineItemRefundBaseMeta = typeMeta("LineItemRefundBase", {
  amountToRefundUnitCents: propertyMeta(
    "amountToRefundUnitCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountRefundedCents: propertyMeta(
    "amountRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  refundQuantity: propertyMeta(
    "refundQuantity",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  returnStock: propertyMeta(
    "returnStock",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  revokeAfter: propertyMeta(
    "revokeAfter",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  revokeDuring: propertyMeta(
    "revokeDuring",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = LineItemRefundBaseMeta;

registerMeta(() => {});

export class LineItemRefundBaseTracked implements LineItemRefundBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  amountToRefundUnitCents__I?: number = undefined;
  amountToRefundUnitCentsIsSet: boolean = false;
  set amountToRefundUnitCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundUnitCents__I = v;
      this.amountToRefundUnitCentsIsSet = true;
    } else {
      this.amountToRefundUnitCents__I = v || undefined;
      this.amountToRefundUnitCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundUnitCents() {
    return this.amountToRefundUnitCents__I;
  }
  amountRefundedCents__I?: number = undefined;
  amountRefundedCentsIsSet: boolean = false;
  set amountRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountRefundedCents__I = v;
      this.amountRefundedCentsIsSet = true;
    } else {
      this.amountRefundedCents__I = v || undefined;
      this.amountRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountRefundedCents() {
    return this.amountRefundedCents__I;
  }
  refundQuantity__I?: number = undefined;
  refundQuantityIsSet: boolean = false;
  set refundQuantity(v: undefined | number) {
    if (v !== undefined) {
      this.refundQuantity__I = v;
      this.refundQuantityIsSet = true;
    } else {
      this.refundQuantity__I = v || undefined;
      this.refundQuantityIsSet = false;
    }
    this.changeTracker = true;
  }
  get refundQuantity() {
    return this.refundQuantity__I;
  }
  returnStock__I?: boolean = undefined;
  returnStockIsSet: boolean = false;
  set returnStock(v: undefined | boolean) {
    if (v !== undefined) {
      this.returnStock__I = v;
      this.returnStockIsSet = true;
    } else {
      this.returnStock__I = v || undefined;
      this.returnStockIsSet = false;
    }
    this.changeTracker = true;
  }
  get returnStock() {
    return this.returnStock__I;
  }
  revokeAfter__I?: boolean = undefined;
  revokeAfterIsSet: boolean = false;
  set revokeAfter(v: undefined | boolean) {
    if (v !== undefined) {
      this.revokeAfter__I = v;
      this.revokeAfterIsSet = true;
    } else {
      this.revokeAfter__I = v || undefined;
      this.revokeAfterIsSet = false;
    }
    this.changeTracker = true;
  }
  get revokeAfter() {
    return this.revokeAfter__I;
  }
  revokeDuring__I?: boolean = undefined;
  revokeDuringIsSet: boolean = false;
  set revokeDuring(v: undefined | boolean) {
    if (v !== undefined) {
      this.revokeDuring__I = v;
      this.revokeDuringIsSet = true;
    } else {
      this.revokeDuring__I = v || undefined;
      this.revokeDuringIsSet = false;
    }
    this.changeTracker = true;
  }
  get revokeDuring() {
    return this.revokeDuring__I;
  }
  constructor(config?: LineItemRefundBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: LineItemRefundBaseOptional,
    options?: AssignOptions,
  ): LineItemRefundBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.amountToRefundUnitCents &&
      this.amountToRefundUnitCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundUnitCents = config.amountToRefundUnitCents;
      if (optionsRequired.unassign) this.amountToRefundUnitCentsIsSet = false;
      else this.amountToRefundUnitCentsIsSet = true;
    }
    if (
      config.amountRefundedCents &&
      this.amountRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountRefundedCents = config.amountRefundedCents;
      if (optionsRequired.unassign) this.amountRefundedCentsIsSet = false;
      else this.amountRefundedCentsIsSet = true;
    }
    if (
      config.refundQuantity &&
      this.refundQuantityApplyFilter(optionsRequired.filter)
    ) {
      this.refundQuantity = config.refundQuantity;
      if (optionsRequired.unassign) this.refundQuantityIsSet = false;
      else this.refundQuantityIsSet = true;
    }
    if (
      config.returnStock &&
      this.returnStockApplyFilter(optionsRequired.filter)
    ) {
      this.returnStock = config.returnStock;
      if (optionsRequired.unassign) this.returnStockIsSet = false;
      else this.returnStockIsSet = true;
    }
    if (
      config.revokeAfter &&
      this.revokeAfterApplyFilter(optionsRequired.filter)
    ) {
      this.revokeAfter = config.revokeAfter;
      if (optionsRequired.unassign) this.revokeAfterIsSet = false;
      else this.revokeAfterIsSet = true;
    }
    if (
      config.revokeDuring &&
      this.revokeDuringApplyFilter(optionsRequired.filter)
    ) {
      this.revokeDuring = config.revokeDuring;
      if (optionsRequired.unassign) this.revokeDuringIsSet = false;
      else this.revokeDuringIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemRefundBaseTrackedI {
    const cloned = {} as LineItemRefundBaseTrackedI;
    if (
      this.amountToRefundUnitCentsIsSetDeep() &&
      this.amountToRefundUnitCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundUnitCentsIsSet = true;
      cloned.amountToRefundUnitCents = this.amountToRefundUnitCents;
    } else {
      //cloned.amountToRefundUnitCentsIsSet = false
    }
    if (
      this.amountRefundedCentsIsSetDeep() &&
      this.amountRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountRefundedCentsIsSet = true;
      cloned.amountRefundedCents = this.amountRefundedCents;
    } else {
      //cloned.amountRefundedCentsIsSet = false
    }
    if (
      this.refundQuantityIsSetDeep() &&
      this.refundQuantityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.refundQuantityIsSet = true;
      cloned.refundQuantity = this.refundQuantity;
    } else {
      //cloned.refundQuantityIsSet = false
    }
    if (
      this.returnStockIsSetDeep() &&
      this.returnStockApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.returnStockIsSet = true;
      cloned.returnStock = this.returnStock;
    } else {
      //cloned.returnStockIsSet = false
    }
    if (
      this.revokeAfterIsSetDeep() &&
      this.revokeAfterApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.revokeAfterIsSet = true;
      cloned.revokeAfter = this.revokeAfter;
    } else {
      //cloned.revokeAfterIsSet = false
    }
    if (
      this.revokeDuringIsSetDeep() &&
      this.revokeDuringApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.revokeDuringIsSet = true;
      cloned.revokeDuring = this.revokeDuring;
    } else {
      //cloned.revokeDuringIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemRefundBaseTrackedI {
    if (!this.amountToRefundUnitCentsApplyFilter(filter))
      this.amountToRefundUnitCentsIsSet = false;

    if (!this.amountRefundedCentsApplyFilter(filter))
      this.amountRefundedCentsIsSet = false;

    if (!this.refundQuantityApplyFilter(filter))
      this.refundQuantityIsSet = false;

    if (!this.returnStockApplyFilter(filter)) this.returnStockIsSet = false;

    if (!this.revokeAfterApplyFilter(filter)) this.revokeAfterIsSet = false;

    if (!this.revokeDuringApplyFilter(filter)) this.revokeDuringIsSet = false;

    return this;
  }
  amountToRefundUnitCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundBaseMeta.amountToRefundUnitCents,
      LineItemRefundBaseMeta,
      this.amountToRefundUnitCents,
      this,
    );
  }
  amountToRefundUnitCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundUnitCentsIsSet &&
      this.amountToRefundUnitCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundBaseMeta.amountRefundedCents,
      LineItemRefundBaseMeta,
      this.amountRefundedCents,
      this,
    );
  }
  amountRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountRefundedCentsIsSet &&
      this.amountRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  refundQuantityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundBaseMeta.refundQuantity,
      LineItemRefundBaseMeta,
      this.refundQuantity,
      this,
    );
  }
  refundQuantityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.refundQuantityIsSet && this.refundQuantityApplyFilter(filter))
      return true;

    return false;
  }
  returnStockApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundBaseMeta.returnStock,
      LineItemRefundBaseMeta,
      this.returnStock,
      this,
    );
  }
  returnStockIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.returnStockIsSet && this.returnStockApplyFilter(filter))
      return true;

    return false;
  }
  revokeAfterApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundBaseMeta.revokeAfter,
      LineItemRefundBaseMeta,
      this.revokeAfter,
      this,
    );
  }
  revokeAfterIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.revokeAfterIsSet && this.revokeAfterApplyFilter(filter))
      return true;

    return false;
  }
  revokeDuringApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundBaseMeta.revokeDuring,
      LineItemRefundBaseMeta,
      this.revokeDuring,
      this,
    );
  }
  revokeDuringIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.revokeDuringIsSet && this.revokeDuringApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.amountToRefundUnitCentsIsSetDeep(filter)) return true;
    if (this.amountRefundedCentsIsSetDeep(filter)) return true;
    if (this.refundQuantityIsSetDeep(filter)) return true;
    if (this.returnStockIsSetDeep(filter)) return true;
    if (this.revokeAfterIsSetDeep(filter)) return true;
    if (this.revokeDuringIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
